// extracted by mini-css-extract-plugin
export default {"inputNoRightPadding":"DatePicker_inputNoRightPadding__VIHJR"};